angular.module('unica_agenda.agenda_services', [])

.factory('AgendaService', function ($http, getBaseApiURL) {

	var agendaService = {};

	agendaService.get = function( stageId )
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/agenda/list/' + stageId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.agenda;
			}

		});
	};


	agendaService.save = function (data, eventId, stageId)
	{
		return $http({
			method: 'post',
			url: getBaseApiURL + '/agenda/create',
			data: {
				agenda: data,
				event_id: eventId,
				stage_id: stageId
			}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	agendaService.delete = function ( taskId )
	{
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/agenda/delete/' + taskId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};


	return agendaService;
});